import type { ReactNode } from "react";
import { useEffect } from "react";

import { courseBuilderStore } from "@pm2/course-builder";

/**
 * Handles the creation of the course builder store as soon as the currently
 * active user becomes available.
 */
export function CourseBuilderStoreProvider({
  children,
}: {
  children: ReactNode;
}): React.JSX.Element {
  useEffect(() => {
    // Automatically trigger the panel to open if requested explictly in the
    // URL (given that we must have adequate space to actually open the panel)
    const openPanelOnInit =
      window.matchMedia("(min-width: 1024px)").matches &&
      new URL(window.location.href).searchParams.get("course-builder") ===
        "enabled";

    if (openPanelOnInit) {
      courseBuilderStore.dispatch(courseBuilderStore.actions.togglePanel(true));
    }
  }, []);

  return <>{children}</>;
}
